import React from "react";
import {
  ItemButton,
  PrimaryLine,
  SecondaryLine,
} from "./MemberSearchResultItem.styles";
import type { MemberSearchResultItemProps } from "./MemberSearchResultItem.types";

export const MemberSearchResultItem: React.FC<MemberSearchResultItemProps> = ({
  name,
  email,
  variant = "user",
  hint,
  onSelect,
}) => {
  const isEmailInvite = variant === "email-invite";

  return (
    <ItemButton type="button" role="option" onClick={onSelect}>
      {isEmailInvite ? (
        <>
          <PrimaryLine>Invite {email}</PrimaryLine>
          {hint ? <SecondaryLine>{hint}</SecondaryLine> : null}
        </>
      ) : (
        <>
          <PrimaryLine>{name}</PrimaryLine>
          <SecondaryLine>{email}</SecondaryLine>
        </>
      )}
    </ItemButton>
  );
};

export default MemberSearchResultItem;
